import { MULTI_STOP, ONE_WAY, RETURN } from '../../../constants/tripTypesConstants';
import getTravelersText from '../../../widgets/search-form/utils/getTravelersText';
import { getFormattedDate } from '../../../utils/search';

const setQueryParamsUrl = (searchParams) => {
  let queryParamsUrl = '';
  for (const [key, value] of Object.entries(searchParams)) {
    queryParamsUrl += `${key}=${value}&`;
  }
  return queryParamsUrl.slice(0, -1);
};

const getMultiStopInfo = (tripRoutes) => {
  const destinationCodes = [];
  const originCodes = [];
  const departureDates = [];
  tripRoutes.forEach((route) => {
    destinationCodes.push(route.destinationCode);
    originCodes.push(route.originCode);
    departureDates.push(route.departureDate);
  });
  return {
    destinationCodes: destinationCodes?.join('_'),
    originCodes: originCodes?.join('_'),
    departureDates: departureDates?.join('_'),
  };
};

const getMultiStopRoutes = (departureDate, destinationCode, originCode) => {
  const departureDates = departureDate?.split('_');
  const destinationCodes = destinationCode?.split('_');
  const originCodes = originCode?.split('_');
  const tripRoutes = [];
  for (let i = 0; i < originCodes?.length; i += 1) {
    tripRoutes.push({
      departureDate: getFormattedDate(departureDates[i]),
      destinationCode: destinationCodes[i],
      originCode: originCodes[i],
    });
  }
  return tripRoutes;
};

const getRoutes = (departureDate, destinationCode, originCode, returnDate, tripType) => {
  if (tripType === ONE_WAY) {
    return [
      {
        departureDate: getFormattedDate(departureDate),
        destinationCode,
        originCode,
      },
    ];
  }
  if (tripType === RETURN) {
    return [
      {
        departureDate: getFormattedDate(departureDate),
        destinationCode,
        originCode,
      },
      {
        departureDate: getFormattedDate(returnDate),
        destinationCode: originCode,
        originCode: destinationCode,
      },
    ];
  }
  return getMultiStopRoutes(departureDate, destinationCode, originCode);
};

export const getSearchParams = (searchData, queryParams, oldBrandCode) => {
  const urlSearchParams = Object.fromEntries(queryParams.entries() ?? []);
  const { cabinClass, date, shouldOnlyShowDirectFlights, routes, travelers, tripType } = searchData;
  const childAges = travelers?.childAges?.join('_');
  let searchParams;
  if (tripType !== MULTI_STOP) {
    const { originCode, originCity, destinationCode, destinationCity } = routes[0];

    searchParams = {
      originCode,
      originCity,
      destinationCode,
      destinationCity,
      departureDate: date.departure,
      returnDate: date.return,
      adults: travelers.adults,
      childAges,
      cabinClass,
      direct: shouldOnlyShowDirectFlights,
      tripType,
      oldBrandCode,
      ...urlSearchParams,
    };
  } else {
    const { originCodes, destinationCodes, departureDates } = getMultiStopInfo(routes);
    const originCity = routes[0]?.originCity;
    const destinationCity = routes[routes.length - 1]?.destinationCity;
    searchParams = {
      originCode: originCodes,
      originCity: encodeURIComponent(originCity),
      destinationCode: destinationCodes,
      destinationCity: encodeURIComponent(destinationCity),
      departureDate: departureDates,
      returnDate: null,
      adults: travelers.adults,
      childAges,
      cabinClass,
      direct: shouldOnlyShowDirectFlights,
      tripType,
      oldBrandCode,
      ...urlSearchParams,
    };
  }

  return setQueryParamsUrl(searchParams);
};

export const transformSearchParams = (queryParams, travelerTexts) => {
  const adults = Number(queryParams.get('adults'));
  const childAges = queryParams.get('childAges')
    ? queryParams.get('childAges').split('_').map(Number)
    : [];
  const children = childAges?.filter((age) => age > 1)?.length;
  const tripType = queryParams.get('tripType');
  const departureDate = queryParams.get('departureDate');
  const returnDate = queryParams.get('returnDate');
  const destination = decodeURIComponent(queryParams.get('destinationCity'));
  const destinationCode = queryParams.get('destinationCode');
  const infants = childAges?.filter((age) => age <= 1)?.length;
  const startDate = tripType === MULTI_STOP ? departureDate?.split('_')[0] : departureDate;
  const endDate = queryParams.get('returnDate') !== 'null' ? returnDate : '';
  const origin = decodeURIComponent(queryParams.get('originCity'));
  const originCode = queryParams.get('originCode');
  const travelers = getTravelersText(adults, children, infants, travelerTexts);
  const tripRoutes = getRoutes(departureDate, destinationCode, originCode, returnDate, tripType);

  return {
    adults,
    cabinClass: queryParams.get('cabinClass'),
    childAges,
    children,
    destination,
    direct: queryParams.get('direct') === 'true',
    endDate,
    infants,
    origin,
    routes: tripRoutes,
    startDate,
    travelers,
    tripType,
  };
};
